import { useState } from 'react'
import { Box } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { Button } from 'react-bootstrap'
import { Context, DBServer } from '../../../types/types'
import ServerEditModal from './ServerEditModal'
import { useCreateDBServer, useDBServer, useDeleteDBServer, useUpdateDBServer } from '../../Hooks/Hooks'

export interface DBServerEditorProps {
    context: Context,
}

function ServerEditor(props: DBServerEditorProps) {
  const { data } = useDBServer(props.context.id)
  const create = useCreateDBServer(props.context.id)
  const update = useUpdateDBServer(props.context.id)
  const remove = useDeleteDBServer(props.context.id)

  const [modalOpen, setOpenModal] = useState(false)
  const [selectedRows, setSelectedRows] = useState<DBServer[]>([])
  const [editField, setFieldToEdit] = useState<DBServer | undefined>(undefined)

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 50,
    },
    {
      field: 'name',
      headerName: 'Name',
      width: 150,
    },
    {
      field: 'connection',
      headerName: 'Connection',
      width: 150,
    },
    {
      field: 'username',
      headerName: 'Username',
      width: 150,
    },
    {
      field: 'holds_demo',
      headerName: 'Holds Demo?',
      width: 100,
    },
    {
      field: 'tenant_count',
      headerName: 'Tenant Count',
      width: 100,
    },
    {
      field: 'total_database_user_count',
      headerName: 'Total DB Users',
      width: 120,
    },
  ]

  const openModal = () => {
    if (selectedRows.length === 1) setFieldToEdit(selectedRows[0])
    setOpenModal(true)
  }

  const deleteValues = () => {
    selectedRows.forEach((field: DBServer) => {
      remove.mutate(field.id)
    })
  }

  const saveField = (field: DBServer, createNew?: boolean) => {
    if (createNew) {
      create.mutate(field)
    } else {
      update.mutate(field)
      setSelectedRows([field])
      setFieldToEdit(undefined)
    }
  }

  return (
    <div>
      <ServerEditModal
        open={modalOpen}
        cancel={() => {
          setFieldToEdit(undefined)
          setOpenModal(false)
        }}
        submit={(name: string, connection: string, username: string, password: string, holds_demo: boolean) => {
          const field: DBServer = { id: '', name, username, connection, password, holds_demo, tenant_count: 0, total_database_user_count: 0 }
          if (!editField) {
            saveField(field, true)
          } else {
            field.id = editField.id
            saveField(field)
          }
          setOpenModal(false)
        }}
        field={editField}
      />
      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
        <Button
          onClick={() => {
            openModal()
          }}
        >
          {selectedRows.length === 1 ? 'Edit' : 'Create'}
        </Button>
        <Button disabled={selectedRows.length === 0} onClick={deleteValues}>
          Delete
        </Button>
      </div>
      <div>
        <Box sx={{ height: '640px', width: '100%' }}>
          <DataGrid
            rows={data ?? []}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            onRowSelectionModelChange={(ids: any) => {
              const selectedIDs = new Set(ids)
              const selectedRowData: any = data?.filter((row: any) =>
                selectedIDs.has(row.id)
              )
              setSelectedRows(selectedRowData)
            }}
            pageSizeOptions={[10]}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      </div>
    </div>
  )
}

export default ServerEditor
